module.exports = __webpack_public_path__ + "img/pic_youshi_03.e1daa697.png";